import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

export default function PageHeader({
  title,
  breadcrumbs = [],
  primaryAction,
  secondaryActions = [],
  /** Toolbar control (e.g. Dropdown) — rendered with action buttons, aligned end */
  extra,
}) {
  const hasActions = secondaryActions.length > 0 || primaryAction || extra;

  return (
    <Container fluid className="mh-page-header-wrap">
      <div className="page-title">
        <Row className="align-items-center gy-3">
          <Col xs="6">
            <h3>{title}</h3>
          </Col>
          <Col xs="6">
            <div className="d-flex flex-column align-items-md-end gap-2">
              {breadcrumbs.length > 0 && (
                <ol className="breadcrumb mb-0">
                  {breadcrumbs.map((b, i) => (
                    <li
                      key={i}
                      className={`breadcrumb-item${b.path ? '' : ' active'}`}
                      aria-current={b.path ? undefined : 'page'}
                    >
                      {b.path ? <Link to={b.path}>{b.label}</Link> : b.label}
                    </li>
                  ))}
                </ol>
              )}
              {hasActions && (
                <div className="d-flex flex-wrap gap-2 justify-content-md-end mh-page-actions align-items-center">
                  {secondaryActions.map((a, i) => (
                    <Button
                      key={i}
                      variant={a.variant || 'light'}
                      onClick={a.onClick}
                      disabled={a.disabled}
                    >
                      {a.label}
                    </Button>
                  ))}
                  {primaryAction && (
                    <Button
                      variant="primary"
                      onClick={primaryAction.onClick}
                      disabled={primaryAction.disabled}
                    >
                      {primaryAction.label}
                    </Button>
                  )}
                  {extra}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
